import { GET_ATTENDANCE_GROUPS } from '../../mutation-types';
import { getGroups } from '@/services/attendance-groups-service';

const actions = {
  getAttendanceGroups({ commit }, agentId) {
    getGroups(agentId).then((res) => {
      commit(GET_ATTENDANCE_GROUPS, res);
    });
  },
  reset({ commit }) {
    commit(RESET_ATETENDANCE);
  },
};

export default actions;
